export { default as LifestylesCategoriesFilterBadge } from './LifestylesCategoriesFilterBadge';
